import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { baseUrl, customHeaders, umsUrl, adminAPIURL } from '../../../../../Containers/Config/index.js';
import { GET_ISSUE_TYPES, GET_ISSUE_TYPES_SUCCESS, GET_ISSUE_TYPES_ERROR } from '../../actions.js';
import apiCall from '../../../apiCall.js';

function* getIssueTypes({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v2/ticket-system/issue-types`,
      method: 'GET',
      headers: {
        // Authorization: Constant?.CLIENT_TOKEN,
        ...filteredHeaders,
        // withCredentials: true
      },
      params: payload?.urlParams,
    });

    if (response.status === 200) {
      yield put({
        type: GET_ISSUE_TYPES_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: GET_ISSUE_TYPES_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: GET_ISSUE_TYPES_ERROR, payload: error });
  }
}

export function* watchGetIssueTypes() {
  yield takeEvery(GET_ISSUE_TYPES, getIssueTypes);
}

function* getIssueTypesSaga() {
  yield all([fork(watchGetIssueTypes)]);
}

export default getIssueTypesSaga;